import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPostKey } from '../../utils/keys';
import { useCachedPost } from '../cache';
export const usePost = (options) => {
    const { id, fields = 'default', useQueryOptions } = options;
    const { client } = useTribeClient();
    const postKey = getPostKey(id);
    const placeHolderPost = useCachedPost(id);
    return useQuery(postKey, () => client.posts.get(id, fields), {
        placeholderData: () => placeHolderPost,
        ...useQueryOptions,
    });
};
//# sourceMappingURL=usePost.js.map